import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=ea64d772&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=ea64d772&prod&scoped=true&lang=css"
import style1 from "./UpdatePassword.vue?vue&type=style&index=1&id=ea64d772&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea64d772",
  null
  
)

export default component.exports